"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCardCoupon = addCardCoupon;
exports.copyCardCoupon = copyCardCoupon;
exports.deleteCardCoupon = deleteCardCoupon;
exports.getCardCouponDetail = getCardCouponDetail;
exports.getCardCouponList = getCardCouponList;
exports.getCompanyList = getCompanyList;
exports.getFucardList = getFucardList;
exports.getParkingLotList = getParkingLotList;
exports.getPriceAdjustmentRecords = getPriceAdjustmentRecords;
exports.offShelfCardCoupon = offShelfCardCoupon;
exports.putOnShelfCardCoupon = putOnShelfCardCoupon;
exports.updateCardCoupon = updateCardCoupon;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取卡券商品列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.productName - 商品名称（模糊查询）
 * @param {string} params.status - 状态 0:下架 1:上架
 */
function getCardCouponList(params) {
  return (0, _request.default)({
    url: '/admin/parking/card/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取卡券商品详情
 * @param {number} id - 商品ID
 */
function getCardCouponDetail(id) {
  return (0, _request.default)({
    url: "/admin/parking/card/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 新增卡券商品
 * @param {Object} data - 商品数据
 */
function addCardCoupon(data) {
  return (0, _request.default)({
    url: '/admin/parking/card/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑卡券商品
 * @param {Object} params - 商品数据
 */
function updateCardCoupon(data) {
  return (0, _request.default)({
    url: '/admin/parking/card/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除卡券商品
 * @param {number} id - 商品ID
 */
function deleteCardCoupon(id) {
  return (0, _request.default)({
    url: "/admin/store/cardCoupon/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 上架卡券商品
 * @param {number} id - 商品ID
 */
function putOnShelfCardCoupon(id) {
  return (0, _request.default)({
    url: "/admin/parking/card/putOnShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 下架卡券商品
 * @param {number} id - 商品ID
 */
function offShelfCardCoupon(id) {
  return (0, _request.default)({
    url: "/admin/parking/card/offShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 复制卡券商品
 * @param {number} id - 商品ID
 */
function copyCardCoupon(id) {
  return (0, _request.default)({
    url: "/admin/store/cardCoupon/copy/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取调价记录
 * @param {number} parkingCardId - 停车卡ID
 */
function getPriceAdjustmentRecords(parkingCardId) {
  return (0, _request.default)({
    url: '/admin/parking/card/price/log',
    method: 'GET',
    params: {
      parkingCardId: parkingCardId
    }
  });
}

/**
 * 获取公司列表（用于使用人群选择）
 * @param {string} keyword - 搜索关键词
 */
function getCompanyList(keyword) {
  console.log('getCompanyList', keyword);
  return (0, _requestMapi.default)({
    //url: '/admin/business/company/autoList',
    url: '/mapi/user/company/autoList',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 获取停车场列表（自动补全）
 * @param {string} keyword - 搜索关键词
 */
function getParkingLotList(keyword) {
  console.log('getParkingLotList', keyword);
  return (0, _request.default)({
    url: '/admin/parking/lot/autocomplete',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 获取福卡列表（用于福卡选择）
 * @param {string} keyword - 搜索关键词
 */
function getFucardList(keyword) {
  console.log('getFucardList', keyword);
  var params = {
    keyword: keyword || ''
  };
  console.log('params', params);
  // return request({
  //   url: '/admin/fudou/fucard/select',
  //   method: 'get',
  //   params,
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/asset/web/fudou/fucard/v2/select',
    method: 'get',
    params: params
  });
}